import { Adapter as o } from "../../adapter.js";
import { SpecialDayTimeSlotModel as r } from "./specialDayTimeSlot.model.js";
class l extends o {
  adapt(e) {
    return new r({
      fullDay: e.full_day,
      endTime: e.end_time,
      startTime: e.start_time,
      weekDays: e.week_days ?? [],
      year: e.year,
      month: e.month,
      day: e.day,
      closed: e.closed,
      timezone: e.timezone
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as SpecialDayTimeSlotAdapter
};
//# sourceMappingURL=specialDayTimeSlot.adapter.js.map
